import { Asset } from "@models/interfaces/asset";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { SocketService } from "../socket.service";
import { InitService } from "@core-services/init.service";
import { TradableService } from "./tradable.service";

export abstract class AssetService<A extends Asset> extends TradableService<A> {
	public abstract startSockets(): void;
	public abstract logoUrl(item: A, grayVersion: boolean): string;

	public constructor(
		protected initService: InitService,
		protected destructor: DestructorService,
		protected translationService: TranslationService,
		protected socketService: SocketService,
		name: string
	) {
		super(initService, destructor, socketService, translationService, name);
	}
}
